// extracted by mini-css-extract-plugin
module.exports = {"ComplianceTestSection":"Index_ComplianceTestSection__YF2eX","MainContent":"Index_MainContent__OfmU2","RowReverse":"Index_RowReverse__kRq_N"};